import SVRedirect from '@apps/www/src/www/containers/SVRedirect';

const SVSiteMakerPage = () => {
	return <SVRedirect to="/site-maker/create/" />;
};

export default SVSiteMakerPage;
